import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import { User } from '@nx-frontend/shared/types';
import { NotificationPanelMemberIcon } from './notification-panel-member-icon';
import { $notificationPanelFilter } from './store';

interface NotificationPanelFilterSelectedMembersProps {
  members: User[];
}

export const NotificationPanelFilterSelectedMembers = (props: NotificationPanelFilterSelectedMembersProps) => {
  const { members } = props;
  const [notificationPanelFilter] = useUnit([$notificationPanelFilter]);

  const selectedMembers = useMemo(() => {
    const orderedMembers: Record<number, User> = {};
    notificationPanelFilter.userIds.forEach((userId) => {
      const member = members.find((member) => member.id === userId);
      if (!member) return;
      orderedMembers[userId] = member;
    });
    return Object.values(orderedMembers);
  }, [members, notificationPanelFilter.userIds]);

  const items = useMemo(() => {
    return selectedMembers
      .slice(0, 2)
      .map((member) => (
        <NotificationPanelMemberIcon
          key={member.id}
          member={member}
          additionalClasses="border border-neutral-200 -ml-[4px]"
        />
      ));
  }, [selectedMembers]);

  const more = useMemo(() => {
    return selectedMembers.length > 2 ? (
      <span className="text-[10px] leading-3 font-semibold ml-[3px]">{` +${selectedMembers.length - 2}`}</span>
    ) : null;
  }, [selectedMembers]);

  if (!notificationPanelFilter.userIds.length) return null;

  return (
    <>
      {items}
      {more}
    </>
  );
};
